// Session-level cache for unit detail responses
const CACHE_VERSION = 2;

interface CacheEntry {
  version: number;
  data: any;
}

const unitDetailCache = new Map<string, CacheEntry>();

export function getUnitDetailCache(vin: string) {
  const entry = unitDetailCache.get(vin);
  if (entry && entry.version === CACHE_VERSION) {
    return entry.data;
  }
  if (entry) {
    unitDetailCache.delete(vin);
  }
  return null;
}

export function setUnitDetailCache(vin: string, data: any) {
  unitDetailCache.set(vin, { version: CACHE_VERSION, data });
}

export function clearUnitDetailCache() {
  unitDetailCache.clear();
}

export function clearUnitDetailCacheForVin(vin: string) {
  unitDetailCache.delete(vin);
}
